import { combineReducers } from 'redux';
import { optimistic } from 'redux-optimistic-ui';

import steps from './steps';
import userData from './userData';
import general from './general';

const rootReducer = optimistic(combineReducers({
    steps,
    userData,
    general
}));

export default rootReducer;
